export default __webpack_public_path__ + "static/media/1435.31e2b5cc.png";